import { useEffect, useState } from "react";
import "./WorkingShift.scss";
import SetWorkingShift from "../../components/calendar/setworkingshift/SetWorkingShift";
import WeeklyShiftSchedule from "../../components/calendar/chedule/Schedule";

const WorkingShift = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (data.length === 0) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [data]);

  const getMyshift = (data = []) => {
    const cashier = localStorage.getItem("cashier");

    const filteredData = data.map((item) => ({
      ...item,
      morningShift: (item.morningShift || []).filter(
        (shift) => shift.name === cashier,
      ),
      eveningShift: (item.eveningShift || []).filter(
        (shift) => shift.name === cashier,
      ),
    }));
    return filteredData;
  };



  return (
    <div className="frame-working-shift">
      <div
        className="frame-main-board"
        style={{ display: loading ? "none" : "block" }}
      >
        <WeeklyShiftSchedule
          WorkingShiftData={data}
          setWorkingShiftData={setData}
        />
      </div>
      <div
        className="frame-set-detail-time"
        style={{ display: loading ? "none" : "block" }}
      >
        <SetWorkingShift setData={setData} update={getMyshift(data)} />
      </div>
    </div>
  );
};

export default WorkingShift;
